// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import Vuetify from "vuetify"
import App from "./App.vue"
import router from "@/router"
import store from "@/store"
import VueMoment from "vue-moment"
import "babel-polyfill"
import "vuetify/dist/vuetify.min.css"
import "font-awesome/css/font-awesome.min.css"
import VueCookie from "vue-cookie"
import VueScrollTo from "vue-scrollto"
import VueClipboard from "vue-clipboard2"
import VueCircle from "vue2-circle-progress-vk"
import * as Sentry from "@sentry/vue"

import Loading from "@/components/shared/common/Loading.vue"
import ErrorPage from "@/components/shared/common/Error.vue"

import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"

function initApp() {
  Vue.config.productionTip = false
  Vue.config.devtools = process.env.ENV !== "production"
  Vue.use(VueCookie)
  Vue.use(VueScrollTo)
  Vue.use(Vuetify)
  Vue.use(VueMoment)
  Vue.use(VueClipboard)
  Vue.use(VueCircle)
  Vue.use(Toast, {
    timeout: 5000,
    closeOnClick: true,
    pauseOnHover: true,
    maxToasts: 3,
    newestOnTop: true,
    showCloseButtonOnHover: true,
    toastClassName: "toasty",
  })
  Vue.component("Loading", Loading)
  Vue.component("ErrorPage", ErrorPage)

  Sentry.init({
    Vue,
    dsn: "https://66a5db60b683454e89c9821b722e1df4@o1059253.ingest.sentry.io/4504894285348864",
    environment: process.env.ENV,
    withCredentials: true,
    trackComponents: true,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    integrations: [
      Sentry.breadcrumbsIntegration({
        console: false,
      }),
      Sentry.replayIntegration({
        maskAllText: false,
      }),
      Sentry.browserTracingIntegration({
        routingInstrumentation: router,
        tracePropagationTargets: [
          /deploy-preview-\d+--soccerpulse-staging\.netlify\.app/g,
          /soccerpulse-staging\.netlify\.app/g,
          "soccerpulse.app",
          /^\//,
        ],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampler: () => (process.env.NODE_ENV === "production" ? 1 : 0.2),
  })

  let app = null
  if (app) {
    return
  }
  app = new Vue({
    el: "#app",
    vuetify: new Vuetify({
      treeShake: true,
      theme: {
        themes: {
          light: {
            warning: "#F59B1A", // $orange
            primary: "#4abe5d", // $bright-green
            accent: "#cda800", // $yellow
          },
          dark: {
            warning: "#F59B1A",
            primary: "#4abe5d",
            accent: "#cda800", // $yellow
          },
        },
      },
    }),
    router,
    store,
    components: {
      App,
    },
    template: "<App/>",
  })
}

initApp()
